import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { useNavigate, useParams } from "react-router-dom";
import closeButton from "../../../images/x.png";
import iconTalk from "../../../images/map/talk.svg";
import iconExhibit from "../../../images/map/exhibition.svg";
import iconPanel from "../../../images/map/panel.svg";
import iconRetail from "../../../images/map/retail.svg";
import iconSlideControl from "../../../images/map/slide-control.svg";
import { toggleMap } from "../actions/map";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
var icons = [{
  name: "talk",
  image: iconTalk
}, {
  name: "exhibit",
  image: iconExhibit
}, {
  name: "panel",
  image: iconPanel
}, {
  name: "retail",
  image: iconRetail
}];
var accessToken = "pk.eyJ1IjoibnljanciLCJhIjoiY21jMzc3NjV6MDFyeTJrcTU3bWhscDNtYSJ9.-50phwp1452H2lt5AH_8fw";
// mapboxgl.accessToken = accessToken;

var Dates = function Dates(_ref) {
  var dates = _ref.dates,
    isOpen = _ref.isOpen,
    _onChange = _ref.onChange;
  var renderDates = function renderDates(date, i) {
    var weekday = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    var dayOfWeek = new Date(date).getDay();
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: "date-".concat(i),
      className: "nycjw-map-date-item",
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: dates[date],
        onChange: function onChange() {
          return _onChange(date);
        },
        size: "small",
        sx: {
          padding: "0 .5rem 0 0",
          "&.Mui-checked": {
            color: "#000"
          }
        }
      }),
      label: weekday[dayOfWeek]
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "nycjw-map-dates",
    className: "".concat(isOpen ? "opened" : "")
  }, /*#__PURE__*/React.createElement("h3", null, "Filter By Dates"), /*#__PURE__*/React.createElement(FormGroup, null, Object.keys(dates).map(renderDates)));
};
var Legend = function Legend(props) {
  var renderCategoryKeys = function renderCategoryKeys(category, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "nycjw-map-legend-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: props.categories[category].icon
    }), /*#__PURE__*/React.createElement("span", null, props.categories[category].name));
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "nycjw-map-legend"
  }, /*#__PURE__*/React.createElement("h3", null, "Categories"), Object.keys(props.categories).map(renderCategoryKeys));
};
var Marker = function Marker(_ref2) {
  var onClick = _ref2.onClick,
    onEnter = _ref2.onEnter,
    onLeave = _ref2.onLeave,
    children = _ref2.children,
    event = _ref2.event;
  var _onClick = function _onClick() {
    onClick(event);
  };
  var _onEnter = function _onEnter() {
    onEnter(event);
  };
  var _onLeave = function _onLeave() {
    onLeave();
  };
  var icon = null;
  if (event.event_types) {
    switch (event.event_types[0].slug) {
      case "exhibition":
      case "reception":
        icon = iconExhibit;
        break;
      case "panel":
      case "workshop":
        icon = iconPanel;
        break;
      case "artist-talk":
      case "talk":
        icon = iconTalk;
        break;
      case "retail-event":
        icon = iconRetail;
        break;
      default:
        icon = iconExhibit;
        break;
    }
  }
  return /*#__PURE__*/React.createElement("button", {
    onClick: _onClick,
    onMouseEnter: _onEnter,
    className: "marker"
  }, icon && /*#__PURE__*/React.createElement("img", {
    src: icon
  }));
};
var Tooltip = function Tooltip(_ref3) {
  var event = _ref3.event,
    clickDetails = _ref3.clickDetails;
  var id = event.id,
    location = event.location,
    title = event.title;
  var address = location.address.replace(/\,/g, "");
  var directionsUrl = address.replace(/\ /g, "%20");
  return /*#__PURE__*/React.createElement("div", {
    className: "map-tooltip",
    id: "tooltip-".concat(id)
  }, /*#__PURE__*/React.createElement("h3", {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), location && /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: location.address
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn small details",
    onClick: function onClick() {
      return clickDetails();
    }
  }, "Details"), /*#__PURE__*/React.createElement("button", {
    className: "btn small directions",
    onClick: function onClick() {
      return window.open("https://maps.google.com/?q=".concat(directionsUrl), "_blank");
    }
  }, "Get Directions"));
};
var Map = function Map() {
  var mapToggled = useSelector(function (state) {
    return state.mapToggled;
  });
  var mapDate = useSelector(function (state) {
    return state.mapDate;
  });
  var events = useSelector(function (state) {
    return state.events;
  });
  var mapContainer = useRef(null);
  var mapWrapper = useRef(null);
  var map = useRef(null);
  // const tooltipRef = useRef(new mapboxgl.Popup({ offset: 10 }));

  var navigate = useNavigate();
  var dispatch = useDispatch();
  var params = useParams();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    mapDates = _useState2[0],
    setMapDates = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    allEvents = _useState4[0],
    setAllEvents = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    openDateFilter = _useState6[0],
    setOpenDateFilter = _useState6[1];
  var _useState7 = useState(-73.97915),
    _useState8 = _slicedToArray(_useState7, 2),
    lng = _useState8[0],
    setLng = _useState8[1];
  var _useState9 = useState(40.7590403),
    _useState10 = _slicedToArray(_useState9, 2),
    lat = _useState10[0],
    setLat = _useState10[1];
  var _useState11 = useState(12),
    _useState12 = _slicedToArray(_useState11, 2),
    zoom = _useState12[0],
    setZoom = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    bounds = _useState14[0],
    setBounds = _useState14[1];
  useEffect(function () {
    if (map.current || !events) return; // initialize map only once
    // map.current = new mapboxgl.Map({
    //   container: mapContainer.current,
    //   style: "mapbox://styles/bpbkny/cjlpmcnpa7t812speb0hkee3q",
    //   center: [lng, lat],
    //   zoom: zoom,
    // });
  }, [events]);
  useEffect(function () {
    if (!events || !map.current) return;
    var boundsArray = bounds;
    map.current.on("load", function () {
      var eventLocations = [];
      Object.keys(events).forEach(function (eventDate) {
        var dayEvents = events[eventDate];
        dayEvents.forEach(function (dayEvent) {
          if (!dayEvent.location) return;
          if (!dayEvent.location.lat) return;
          var datesArray = [];
          if (dayEvent.date) {
            datesArray.push(dayEvent.date);
          }
          // If multiple dates, add all dates into array
          if (dayEvent.dates) {
            datesArray = dayEvent.dates.map(function (date) {
              return date.event_date;
            });
          }
          // If range of dates, add all dates into array
          if (dayEvent.start_date) {
            var startDate = dayEvent.start_date.split("-")[2];
            var endDate = dayEvent.end_date.split("-")[2];
            for (var i = startDate; i <= endDate; i++) {
              datesArray.push("2022-11-".concat(i));
            }
          }
          boundsArray.push([dayEvent.location.lng, dayEvent.location.lat]);
          eventLocations.push(_objectSpread(_objectSpread({
            id: dayEvent.location.place_id,
            lng: dayEvent.location.lng,
            lat: dayEvent.location.lat,
            dates: datesArray
          }, dayEvent), {}, {
            permalink: dayEvent.durational ? "/on-going/".concat(dayEvent.event_types[0].slug, "/").concat(dayEvent.permalink) : dayEvent.date ? "/one-time/".concat(dayEvent.date, "/").concat(dayEvent.permalink) : "/one-time/".concat(dayEvent.start_date, "/").concat(dayEvent.permalink)
          }));
        });
      });
      setAllEvents(eventLocations);
      icons.forEach(function (icon) {
        var iconImage = new Image(40, 40);
        iconImage.src = icon.image;
        map.current.addImage(icon.name, iconImage);
      });
      addSourceAndLayersToMap(eventLocations);
    });
  }, [events, map]);
  var addSourceAndLayersToMap = function addSourceAndLayersToMap(eventLocations) {
    map.current.addSource("events", {
      type: "geojson",
      // Point to GeoJSON data. This example visualizes all M1.0+ earthquakes
      // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
      // data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson',
      data: {
        type: "FeatureCollection",
        features: eventLocations.map(function (item) {
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [item.lng, item.lat]
            },
            properties: _objectSpread(_objectSpread({}, item), {}, {
              id: item.id,
              geometry: {
                type: "Point",
                coordinates: [item.lng, item.lat]
              }
            })
          };
        })
      },
      cluster: true,
      clusterMaxZoom: 14,
      // Max zoom to cluster points on
      clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
    });
    map.current.addLayer({
      id: "clusters",
      type: "circle",
      source: "events",
      filter: ["has", "point_count"],
      paint: {
        // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
        // with three steps to implement three types of circles:
        //   * Blue, 20px circles when point count is less than 100
        //   * Yellow, 30px circles when point count is between 100 and 750
        //   * Pink, 40px circles when point count is greater than or equal to 750
        "circle-color": ["step", ["get", "point_count"], "#000", 100, "#000", 750, "#000"],
        "circle-radius": ["step", ["get", "point_count"], 14, 100, 14, 750, 14]
      }
    });
    map.current.addLayer({
      id: "cluster-count",
      type: "symbol",
      source: "events",
      filter: ["has", "point_count"],
      layout: {
        "text-field": "{point_count_abbreviated}",
        "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
        "text-size": 12
      },
      paint: {
        "text-color": "#fff"
      }
    });
    map.current.addLayer({
      id: "unclustered-point",
      type: "circle",
      source: "events",
      filter: ["!", ["has", "point_count"]],
      paint: {
        "circle-color": "#000",
        "circle-radius": 10,
        "circle-stroke-width": 1,
        "circle-stroke-color": "#fff"
      }
    });
    map.current.addLayer({
      id: "unclustered-count",
      type: "symbol",
      filter: ["!", ["has", "point_count"]],
      source: "events",
      layout: {
        "icon-image": ["match",
        // Use the 'match' expression: https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
        ["get", "icon"], "exhibition", "exhibit", "talk", "talk", "panel", "panel", "retail-event", "retail", "", "exhibit", "exhibit"],
        "icon-size": 0.5
      }
    });

    // inspect a cluster on click
    map.current.on("click", "clusters", function (e) {
      var features = map.current.queryRenderedFeatures(e.point, {
        layers: ["clusters"]
      });
      var clusterId = features[0].properties.cluster_id;
      map.current.getSource("events").getClusterExpansionZoom(clusterId, function (err, zoom) {
        if (err) return;
        map.current.easeTo({
          center: features[0].geometry.coordinates,
          zoom: zoom
        });
      });
    });

    // When a click event occurs on a feature in
    // the unclustered-point layer, open a popup at
    // the location of the feature, with
    // description HTML from its properties.
    map.current.on("click", "unclustered-point", function (e) {
      var coordinates = JSON.parse(e.features[0].properties.geometry).coordinates.slice();
      var _e$features$0$propert = e.features[0].properties,
        id = _e$features$0$propert.id,
        title = _e$features$0$propert.title,
        location = _e$features$0$propert.location,
        permalink = _e$features$0$propert.permalink;
      location = JSON.parse(location);
      var address = location.address.replace(/\,/g, "");
      var directionsUrl = address.replace(/\ /g, "%20");

      // Ensure that if the map is zoomed out such that
      // multiple copies of the feature are visible, the
      // popup appears over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      var popups = document.getElementsByClassName("mapboxgl-popup");
      if (popups.length) {
        popups[0].remove();
      }
      // new mapboxgl.Popup()
      //   .setLngLat(coordinates)
      //   .setHTML(
      //     `<div class="map-tooltip" id="tooltip-${id}">
      //       <h3>${title}</h3>
      //       ${location && `<p>${location.address}</p>`}
      //       <button class="btn small details" id="details-${id}">
      //         Details
      //       </button>
      //       <button
      //         type="button"
      //         class="btn small directions"
      //         onClick="window.open('https://maps.google.com/?q=${directionsUrl}', '_blank')">
      //         Get Directions
      //       </button>
      //     </div>`
      //   )
      //   .addTo(map.current);
      document.getElementById("details-".concat(id)).addEventListener("click", function () {
        return navigateTo(permalink);
      });
    });
    map.current.on("mouseenter", "clusters", function () {
      map.current.getCanvas().style.cursor = "pointer";
    });
    map.current.on("mouseleave", "clusters", function () {
      map.current.getCanvas().style.cursor = "";
    });
  };
  var navigateTo = function navigateTo(permalink) {
    navigate(permalink, {
      replace: true
    });
  };
  useEffect(function () {
    if (!map.current || bounds.length === 0) return;
    // var maxBounds = bounds.reduce(function (bound, coord) {
    //   return bound.extend(coord);
    // }, new mapboxgl.LngLatBounds(bounds[0], bounds[0]));
    // map.current.fitBounds(maxBounds, {
    //   padding: 60,
    // });
  }, [bounds, map]);
  useEffect(function () {
    var mapDates = {};
    eventIntros.forEach(function (intro) {
      mapDates[intro] = true;
    });
    if (mapDate) {
      Object.keys(mapDates).forEach(function (mapDate) {
        mapDates[mapDate] = mapDate === params.cat;
      });
      var filteredEvents = [];
      filteredEvents = allEvents.filter(function (eventItem) {
        return eventItem.dates.includes(params.cat);
      });
      map.current.removeLayer("clusters");
      map.current.removeLayer("cluster-count");
      map.current.removeLayer("unclustered-point");
      map.current.removeLayer("unclustered-count");
      map.current.removeSource("events");
      addSourceAndLayersToMap(filteredEvents);
    }
    setMapDates(mapDates);
  }, [mapDate]);
  var handleChangeDate = function handleChangeDate(date) {
    var cloneMapDates = _objectSpread(_objectSpread({}, mapDates), {}, _defineProperty({}, date, !mapDates[date]));
    setMapDates(cloneMapDates);
    map.current.removeLayer("clusters");
    map.current.removeLayer("cluster-count");
    map.current.removeLayer("unclustered-point");
    map.current.removeLayer("unclustered-count");
    map.current.removeSource("events");
    var activeDates = Object.keys(cloneMapDates).filter(function (keyDate) {
      return cloneMapDates[keyDate];
    });
    var filteredEvents = [];
    if (activeDates.length > 0) {
      filteredEvents = allEvents.filter(function (eventItem) {
        return activeDates.some(function (activeDate) {
          return eventItem.dates.includes(activeDate);
        });
      });
    }
    addSourceAndLayersToMap(filteredEvents);
  };
  var handleCloseMap = function handleCloseMap(event) {
    if (mapWrapper && mapWrapper.current === event.target) {
      event.preventDefault();
      dispatch(toggleMap(false));
    }
  };
  var categories = {
    exhibit: {
      name: "Exhibit/Receiption",
      icon: iconExhibit
    },
    panel: {
      name: "Panel/Workshop",
      icon: iconPanel
    },
    talk: {
      name: "Talk",
      icon: iconTalk
    },
    retail: {
      name: "Retail Event",
      icon: iconRetail
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "nycjw-map-container",
    ref: mapWrapper,
    onClick: handleCloseMap,
    className: mapToggled ? "active" : ""
  }, /*#__PURE__*/React.createElement("div", {
    id: "nycjw-map-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    ref: mapContainer,
    id: "nycjw-map",
    onClick: function onClick() {
      return setOpenDateFilter(false);
    }
  }), /*#__PURE__*/React.createElement("button", {
    id: "close-map",
    onClick: function onClick() {
      return dispatch(toggleMap(false));
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: closeButton
  })), /*#__PURE__*/React.createElement("button", {
    id: "slide-control-map",
    onClick: function onClick() {
      return setOpenDateFilter(true);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: iconSlideControl,
    alt: "slide control"
  })), /*#__PURE__*/React.createElement(Dates, {
    dates: mapDates,
    onChange: handleChangeDate,
    isOpen: openDateFilter
  }), /*#__PURE__*/React.createElement(Legend, {
    categories: categories
  })));
};
export default Map;